import React from "react"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { RoleType, StorageKey } from "../../App/enums"
import { formatDate } from "../../App/Helpers/Helpers"
import { selectTranslations } from "../../App/i18n/i18nSlice"
import SessionService from "../../App/SessionService"
import { RootState } from "../../App/store"
import { setPostStatus } from "../Room/RoomPost/RoomPostSlice"
import { Calendar, CalendarActive, NotificationsActiveIcon, NotificationsIcon } from "../Shared/Components/SvgIcons"
import UpcomingEventsDropdownItem from "./UpcomingEventsDropdownItem"
import Button from "../Shared/Primitive/Button"

function UpcomingEventsDropdown() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const events = useSelector((state: RootState) => state.upcomingEventsSlice.upcomingEvents)
    const [hasEvents, setHasEvents] = useState<boolean>()
    const [hasUpcomingEvents, setHasUpcomingEvents] = useState<boolean>()
    const translation = useSelector(selectTranslations)
    const [notificationsOpen, setNotificationsOpen] = useState(false)
    const { id, roomId } = useParams()
    const orgId = SessionService.getItem(StorageKey.organizationId)
    const notificationFilterNumber = 5
    const lastNotificationIndex = notificationFilterNumber - 1
    let notificationRef = React.useRef() as React.MutableRefObject<HTMLInputElement>

    useEffect(() => {
        const onMouseDownHandler = (event: Event) => {
            if (notificationsOpen && notificationRef.current && !notificationRef.current.contains(event.target as HTMLElement)) {
                setNotificationsOpen(false)
            }
        }
        document.addEventListener("mousedown", onMouseDownHandler)
    })

    const onEventClick = (eventId: number, roomId: number) => {
        switch (role) {
            case RoleType.USER:
                navigate(`/room/${roomId}?tab=events&event=${eventId}`)
                break
            case RoleType.ORGANIZATION:
                navigate(`/room/${id!}/${roomId}?tab=events&event=${eventId}`)
                break
            default:
                break
        }

        setNotificationsOpen(false)
    }

    const onRouteChange = () => {
            switch (role) {
                case RoleType.USER:
                    const userPath = "/upcoming-events"
                    navigate(userPath)
                    window.scrollTo(0, 0)
                    break
                case RoleType.ORGANIZATION:
                    if (id === orgId) {
                        const organizationPath = `/upcoming-events/${id}`
                        navigate(organizationPath)
                        window.scrollTo(0, 0)
                    } else {
                        const organizationPath = `/upcoming-events/${orgId}`
                        navigate(organizationPath)
                        window.scrollTo(0, 0)
                    }
    
                    break
                default:
                    break
            }
        }

    useEffect(() => {
        setHasEvents(events.length > 0)
        setHasUpcomingEvents(events.some((event) => {
            const eventDate = new Date(event.start_date);
            const currentDate = new Date();
            const threeDaysFromNow = new Date();
            threeDaysFromNow.setDate(currentDate.getDate() + 3);
            return eventDate > currentDate && eventDate <= threeDaysFromNow;
        }));
    }, [events.length])


    const onLastItem = (index: number) => {
        if (events.length < notificationFilterNumber) {
            return events.length - 1 === index
        } else {
            return index === lastNotificationIndex
        }
    }

    return (
        <div className="header__menu-notifications" ref={notificationRef}>
            <div
                className="header__icon"
                onClick={() => {
                    setNotificationsOpen(!notificationsOpen)
                }}
            >
                {!hasUpcomingEvents ? <Calendar /> : <CalendarActive />}
            </div>
            {notificationsOpen && (
                <div className="notifications-dropdown">
                    <div className="notifications-dropdown__event-content">
                        <div className="notifications-dropdown__upper-panel">
                            {hasEvents ? (
                                events?.slice(0, notificationFilterNumber).map((event, index) => {
                                    return (
                                        <UpcomingEventsDropdownItem
                                            isLastItem={onLastItem(index)}
                                            name={event.title}
                                            key={event.id}
                                            id={event.id}
                                            format={event.formats}
                                            location={event.location_type}
                                            date={event.start_date}
                                            onClick={() => onEventClick(event.id, event.room.id)}
                                            roomId={event.room.id}
                                            roomName={event.room.name}
                                            isDropDown={true}
                                        />
                                    )
                                })
                            ) : (
                                <div className="notifications-dropdown__text">{translation.youHaveNoUpcomingEvents}</div>
                            )}
                        </div>
                        <div className="notifications-dropdown__lower-panel">
                            {hasEvents && (
                                <div className="notifications-dropdown__button">
                                    <Button
                                        onClick={onRouteChange}
                                        className="button button--border-radius-09 button--color-grey button--hover-darker button--cursor-pointer button--text-color-grey button--font-size-small button--font-weight-400  "
                                    >
                                        {translation.seeAllResults}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}{" "}
        </div>
    )
}

export default UpcomingEventsDropdown
